<div *ngIf="languages.length" class="language-switcher notranslate">
  <select [formControl]="languageControl">
    <option *ngFor="let language of languages; trackBy: trackLanguage" [value]="language.code">
      {{ language.name }}
    </option>
  </select>
  <span *ngIf="languageControl.value" class="{{ 'language-switcher__flag fi fi-' + getFlagCode(languageControl.value) }}"></span>
</div>
